/**
 * Task photo upload limits — must match the backend (be/routes/taskRoutes.js: multer 10 MB,
 * JPEG/PNG/WebP, MAX_TASK_PHOTOS 10). One copy for every screen that uploads a task photo.
 *
 * The server keeps one extra slot for a task's FIRST `issue` photo (the evidence a «لا» guest answer
 * needs), so that one photo is accepted even at the maximum.
 */
export const TASK_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
export const TASK_PHOTO_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const TASK_PHOTO_MAX_COUNT = 10;
